import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { tryToUpdateUserDefaultSettings, tryToFetchMyAccountInfo } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'


class UserSettingsDefaultSettingsForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    let current_settings = props.user.settings || {};

    this.state = {
      format: props.user.updateUserDefaultSettingsForm.lastSubmit.format || current_settings.format,
      type: props.user.updateUserDefaultSettingsForm.lastSubmit.type || current_settings.type,
      units: props.user.updateUserDefaultSettingsForm.lastSubmit.units || current_settings.units,
      private: props.user.updateUserDefaultSettingsForm.lastSubmit.private || current_settings.private,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  componentWillReceiveProps(newprops){
    if(newprops.user.settings && !newprops.user.tryingToUpdateUserDefaultSettings){

      this.setState({
        format: newprops.user.settings.format,
        type: newprops.user.settings.type,
        units: newprops.user.settings.units,
        private: newprops.user.settings.private,
      })
    }
  }


  handleSubmit(e){
    const { dispatch, user } = this.props;
    dispatch(tryToUpdateUserDefaultSettings({
      settings: {
        format: this.state.format,
        type: this.state.type,
        units: this.state.units,
        private: user.roles.pro ? this.state.private : false
      }
    }))

    if(e) e.preventDefault();
  }

  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    if(user.tryingToFetchMyAccountInfo || !user.settings)  return <i className="fal fa-spinner-third fa-spin fa-2x"/>;

    let formDisabled = state.format == user.settings.format && state.type == user.settings.type && state.units == user.settings.units && state.private == user.settings.private;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit(e); 
        }}>
          <p>
            Adjust the default settings that load within Pattycake when creating a new pattern.
          </p>
          <ul className="list-unstyled list-spaced">
            <li>
              <Tabs
                items={[
                    {
                      display: "Revit",
                      value: 'REVIT'
                    },
                    {
                      display: "AutoCAD",
                      value: 'AUTOCAD'
                    }
                  ]}
                value={state.format}
                size='medium'
                onChange={(e) => { this.setState({format: e.value}) }}
                />
            </li>
            
            <li>
               <Tabs
                items={[
                    {
                      display: "Inches",
                      value: 'INCH'
                    },
                    {
                      display: "Millimeters",
                      value: 'MM'
                    }
                  ]}
                value={state.units}
                size='medium'
                onChange={(e) => { this.setState({units: e.value}) }}
                />
            </li>

            <li>
              <Tabs
                items={[
                    {
                      display: "Drafting",
                      value: 'DRAFTING'
                    },
                    {
                      display: "Model",
                      value: 'MODEL'
                    }
                  ]}
                value={state.type}
                size='medium'
                onChange={(e) => { this.setState({type: e.value}) }}
                />
            </li>

            <li>
               <Tabs
                items={[
                    {
                      display: "Public",
                      value: false
                    },
                    {
                      display: "Private",
                      value: true
                    }
                  ]}
                value={state.private}
                size='medium'
                disabled={!user.roles.pro}
                onChange={(e) => { this.setState({private: e.value}) }}
                />
            </li>
          </ul>
          
          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={formDisabled} 
              thinking={user.tryingToUpdateUserDefaultSettings} 
              successful={user.successfullyUpdatedUserDefaultSettings}
              failed={user.failedToUpdatedUserDefaultSettings}
              color="success" 
              display="Save Changes" 
              onClick={this.handleUpdateUserDefaultSettings}
            />
          </div>
        </form>
      </div>
    )
  }
}


UserSettingsDefaultSettingsForm = reduxForm({
  form: 'UserSettingsDefaultSettingsForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsDefaultSettingsForm)

UserSettingsDefaultSettingsForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(UserSettingsDefaultSettingsForm);

export default UserSettingsDefaultSettingsForm;


// WEBPACK FOOTER //
// ./src/components/UserSettingsDefaultSettingsForm/UserSettingsDefaultSettingsForm.js